import { Menu } from '@mui/material';
import styled from 'styled-components';

export const OptionsMenu = styled(Menu)`
  width: 288px;
`;
